import './ProductDescriptionStyle.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'src/core/components';

const ProductDescriptionComponent = ({ row }) => {
  const { name, description, detailsLink } = row.values.nameDescription;

  return (
    <div className="mcp-product-description">
      <Link href={detailsLink}>{name}</Link>
      <div>{description}</div>
    </div>
  );
};

ProductDescriptionComponent.propTypes = {
  row: PropTypes.object.isRequired,
};

export default ProductDescriptionComponent;
